import { CatalogList } from '../../../../CatalogList';
import { CatalogGrid } from '../../../CatalogGrid/CatalogGrid';
import Cookies from 'universal-cookie';
import React, { useContext, useState } from 'react';
import '../groups.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { UserContext } from '../../../../../auth/context/UserContext';

const PAGE_SIZE = 15;

export const GroupedProducts = ({
  groupedProducts,
  isMobile,
  dataClient,
  onProductClick,
  onClearAll,
  products,
}) => {
  const cookies = new Cookies();
  const hasSavedGroups = cookies.get('grupos')?.length > 0;

  const [currentPage, setCurrentPage] = useState(1);
  const { dataUser } = useContext(UserContext);
  const { visualizaStock } = dataUser;

  if (!hasSavedGroups || !products || products.length === 0) {
    return null;
  }

  const organizarPorMarcaRubroSubrubro = (productos) => {
    const grupos = {};

    productos.forEach((producto) => {
      const marca =
        producto.propiedadesConTipo?.find((p) => p.tipo === 'Marca')
          ?.denominacion || 'Sin marca';
      const rubro =
        producto.propiedadesConTipo?.find((p) => p.tipo === 'Rubro')
          ?.denominacion || 'Sin rubro';
      const subrubro =
        producto.propiedadesConTipo?.find((p) => p.tipo === 'Subrubro')
          ?.denominacion || 'Sin subrubro';

      if (!grupos[marca]) grupos[marca] = {};
      if (!grupos[marca][rubro]) grupos[marca][rubro] = {};
      if (!grupos[marca][rubro][subrubro]) grupos[marca][rubro][subrubro] = [];

      grupos[marca][rubro][subrubro].push(producto);
    });

    return grupos;
  };

  const productosOrdenados = [...products].sort((a, b) => {
    const marcaA =
      a.propiedadesConTipo?.find((p) => p.tipo === 'Marca')?.denominacion ||
      'Sin marca';
    const marcaB =
      b.propiedadesConTipo?.find((p) => p.tipo === 'Marca')?.denominacion ||
      'Sin marca';
    return marcaA.localeCompare(marcaB);
  });

  const totalPages = Math.ceil(productosOrdenados.length / PAGE_SIZE);
  const start = (currentPage - 1) * PAGE_SIZE;
  const end = start + PAGE_SIZE;
  const productosPaginados = productosOrdenados.slice(start, end);

  const gruposOrganizados = organizarPorMarcaRubroSubrubro(productosPaginados);

  const renderPagination = () => {
    if (totalPages <= 1) return null;

    const sumaPagina = () => {
      if (currentPage < totalPages) {
        setCurrentPage(currentPage + 1);
      }
    };

    const restaPagina = () => {
      if (currentPage > 1) {
        setCurrentPage(currentPage - 1);
      }
    };

    return (
      <div className="paginacion">
        <button
          className="paginacion-antes"
          onClick={restaPagina}
          disabled={currentPage === 1}
        >
          <FontAwesomeIcon icon={faChevronLeft} className="iconleft" />
          Anterior
        </button>
        <span className="paginacion-centro">
          {currentPage} de {totalPages}
        </span>
        <button
          className="paginacion-despues"
          onClick={sumaPagina}
          disabled={currentPage === totalPages}
        >
          Siguiente
          <FontAwesomeIcon icon={faChevronRight} className="iconright" />
        </button>
      </div>
    );
  };

  const renderDesktopView = () => (
    <div className="contenedortabla">
      <table className="tabla">
        <thead className="tabla__encabezado">
          <tr>
            <th className="tabla__titulo tabla__media codigo">Código</th>

            <th className="tabla__titulo tabla__media codigo_sin">Sinónimo</th>

            <th className="tabla__titulo tabla__desc descripcion">
              Descripción
            </th>
            {visualizaStock ? (
              <th className="tabla__titulo tabla__media stocks tabla__num">
                Stock
              </th>
            ) : (
              <th></th>
            )}

            <th
              className={
                !dataClient
                  ? 'tabla__titulo tabla__precio precio tabla__num'
                  : 'tabla__titulo tabla__precio precios tabla__num'
              }
            >
              Precio
            </th>
            {dataClient && (
              <th
                className="tabla__titulo cell-actions-table precio"
                style={{
                  borderBottomRightRadius: '4px',
                  borderTopRightRadius: '4px',
                }}
              >
                Cantidad
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {Object.entries(gruposOrganizados).map(([marca, rubros]) => (
            <React.Fragment key={`marca-${marca}`}>
              {Object.entries(rubros).map(([rubro, subrubros]) => (
                <React.Fragment key={`rubro-${marca}-${rubro}`}>
                  {Object.entries(subrubros).map(([subrubro, productos]) => (
                    <React.Fragment
                      key={`subrubro-${marca}-${rubro}-${subrubro}`}
                    >
                      <tr className="group-header">
                        <td colSpan={dataClient ? 6 : 5}>
                          <div>
                            <h4 className="grupo-rubro">{rubro}</h4>
                            <h5 className="grupo-rubro">{subrubro}</h5>
                          </div>
                        </td>
                      </tr>
                      <tr className="group-header">
                        <td colSpan={dataClient ? 6 : 5}>
                          <h1 className="grupo-rubro">{marca}</h1>
                        </td>
                      </tr>
                      <CatalogList
                        lisArt={productos}
                        onProductClick={onProductClick}
                      />
                    </React.Fragment>
                  ))}
                </React.Fragment>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );

  const renderMobileView = () => (
    <div className="mobile-groups">
      {Object.entries(gruposOrganizados).map(([marca, rubros]) => (
        <div key={`mobile-marca-${marca}`}>
          {Object.entries(rubros).map(([rubro, subrubros]) => (
            <div key={`mobile-rubro-${marca}-${rubro}`}>
              <h4 className="grupo-rubro">{rubro}</h4>

              {Object.entries(subrubros).map(([subrubro, productos]) => (
                <div key={`mobile-subrubro-${marca}-${rubro}-${subrubro}`}>
                  <h5 className="grupo-rubro">{subrubro}</h5>
                  <h2 className="grupo-rubro">{marca}</h2>
                  <CatalogGrid
                    lisArt={productos}
                    onProductClick={onProductClick}
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
      ))}
    </div>
  );

  return (
    <div className="grouped-products-section">
      {!isMobile ? (
        <>
          {renderDesktopView()}
          {renderPagination()}
        </>
      ) : (
        <>
          {renderMobileView()}
          {renderPagination()}
        </>
      )}
    </div>
  );
};
